import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CurrentBilling } from '../../domain/models/billing/current-billing';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BillingService {
  protected http = inject(HttpClient);

  getCurrentBilling(): Observable<CurrentBilling> {
    return this.http.get<CurrentBilling>(
      `${environment.apiUrl}api/billing/current`,
    );
  }

  getCurrentBillingByCompanyId(companyId: string): Observable<CurrentBilling> {
    const params = new HttpParams().set('companyId', companyId);
    return this.http.get<CurrentBilling>(
      `${environment.apiUrl}api/billing/current`,
      { params },
    );
  }
}
